import React from "react";
import { Typography } from "@material-ui/core";
import { Link } from "@reach/router";
import { FormType } from "types/gql-types";
import { ContainerCardLayout } from "components/haven-design";
import { MainLayout } from "pages/Layouts";
import { humanizeFormType } from "utils/form-types";

type FormClosedProps = { propertyName: string; formType: FormType; }

const FormClosedBanner: React.FC<FormClosedProps> =
  ({ propertyName, formType }) => (<Typography variant="body1">
    Thanks for your interest in {propertyName}.&nbsp;
    We&apos;re no longer accepting {humanizeFormType(formType, true)} at this time.
    <br/> <br/>
    <Link id="return-to-properties-page" to="/properties">Find & apply to other properties</Link>
  </Typography>);

const FormClosedLayout: React.FC<FormClosedProps> = (props) => (
  <MainLayout showHeader showFooter backgroundColor="gray">
    <ContainerCardLayout title={`${humanizeFormType(props.formType)} is closed`}>
      <FormClosedBanner {...props} />
    </ContainerCardLayout>
  </MainLayout>
);

export default FormClosedLayout;
